import { Link } from "react-router-dom";
import SEO from "../components/SEO";

const NotFound = () => {
    return (
        <>
            <SEO
                title="Page introuvable — Fiduciaire Bleich"
                description="La page demandée est introuvable."
                canonical="https://fiduciaire-bleich.ch/"
            />
            <section
                data-testid="not-found-page"
                className="bg-white py-32 lg:py-40"
            >
                <div className="container-prose max-w-2xl text-center">
                    <p className="text-xs uppercase tracking-[0.25em] text-[#5C6B70] mb-6">
                        Erreur 404
                    </p>
                    <h1 className="font-serif text-5xl sm:text-6xl text-[#2C3E45] leading-tight tracking-tight mb-6">
                        Page <span className="italic">introuvable.</span>
                    </h1>
                    <p className="text-lg text-[#5C6B70] mb-10">
                        La page que vous cherchez n'existe pas ou a été déplacée.
                    </p>
                    <Link to="/" data-testid="not-found-home-link" className="btn-primary">
                        Retour à l'accueil
                    </Link>
                </div>
            </section>
        </>
    );
};

export default NotFound;
